var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./BrowseMoreProfiles.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-54c68845\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./BrowseMoreProfiles.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/ProfilePage/BrowseMoreProfiles.vue
// module id = 382
// module chunks = 1